import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { getApplicationLogo, addApplicationLogo} from '../action/emailSettingAction';
import LogoSettingComponent from '../components/logoSettingComponent';

export class LogoSettingContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getApplicationLogo();
    }
    getApplicationLogoData = () =>{
        this.props.actions.getApplicationLogo(
            this.props.dispatch
        )
    }
    addLogo = (payload) =>{
        this.props.actions.addApplicationLogo(
            payload,
            this.props.dispatch
        )
    }
    render(){
        return(
            <LogoSettingComponent
                getLogoSettingData = {this.props.logoSettingData}
                addLogo = {this.addLogo}
                getApplicationLogoData = {this.getApplicationLogoData}
            >
            </LogoSettingComponent>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getApplicationLogo,
            addApplicationLogo
        },
            dispatch)
    };
}
function mapStateToProps({ EmailSettingReducer }) {
    console.log(EmailSettingReducer);
    return {
        logoSettingData : {
            errorCode : EmailSettingReducer.errorCode,
            statusCode : EmailSettingReducer.statusCode,
            Message : EmailSettingReducer.Message,
            isLoading : EmailSettingReducer.isLoading,
            emailLogoDetail: EmailSettingReducer.emailLogoDetail
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LogoSettingContainer));
